<template>
  <router-view />
</template>

<script>
export default {
  name: "orders",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
